import { Component, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Route,
  Router,
} from '@angular/router';
import { AnnouncementService } from '../shared/services/announcement.service';
import {
  AnnouncementModerationDetails,
  AnnouncmentModerationRequestViewModel,
} from '../shared/models/announcement-moderation-model';
import {
  AnnouncementModerationAttributeEnum,
  ApplicationMethodEnum,
  EmploymentFormEnum,
} from '../shared/enums/announcement-enums';
import { MessageService } from 'primeng/api';
import { CustomMessageService } from './../../core/message.service';
import { ApplicationMessage } from './../../core/models/application-message';
import { MessageType } from './../../core/models/enum/message-type';
import { ApplicationMessageSource } from './../../core/models/application-message-source';
import { LookupService } from '../../../app/shared/services/lookup.service';
import { CommonLookupItem } from '../../../app/shared/models/common-lookup-item.model';
import { ConfigurationService } from '../../../app/shared/services/configuration.service';

@Component({
  selector: 'app-moderation-announcement',
  templateUrl: './moderation-announcement.component.html',
  styleUrls: ['./moderation-announcement.component.less'],
  standalone: false,
})
export class ModerationAnnouncementComponent implements OnInit {
  public announcement: AnnouncmentModerationRequestViewModel;
  public entityAttributes: any;
  public announcementId: number;
  public alternativeLanguage: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private announcementService: AnnouncementService,
    private config: ConfigurationService
  ) {
    this.entityAttributes = AnnouncementModerationAttributeEnum;
  }

  getAnnouncementData(announcementId) {
    this.announcementService
      .getModerationRelatedAnnouncements(announcementId)
      .subscribe((result: any) => {
        this.announcement = result.data;
      });
  }

  ngOnInit() {
    const config = this.config.getCachedConfig();
    this.alternativeLanguage = config.alternativeLanguage.toUpperCase();
    this.activatedRoute.paramMap.subscribe((params) => {
      this.announcementId = +params.get('announcementId');
      this.getAnnouncementData(this.announcementId);
    });
  }
}
